<script lang="ts">
import { iBadge, iBadgeColours, iSpinner } from '@inscribe/signal';
import { computed } from 'vue';
import { Statuses, statusIcon } from '@/V2/components/status/utils';

export const StatusStyles = {
  OUTLINE: 'outline',
  SOLID: 'solid',
};

export default {
  name: 'StatusBadge',
  components: {
    iBadge,
    iSpinner,
  },
  props: {
    type: {
      type: String,
      default: StatusStyles.SOLID,
      validator: (value: string) => Object.values(StatusStyles).includes(value),
    },
    state: {
      type: String,
      default: Statuses.NOT_APPLICABLE,
      validator: (value: string) => Object.values(Statuses).includes(value),
    },
    label: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const badgeColourMap = (state) => {
      if (iBadgeColours[state?.toUpperCase()]) {
        return iBadgeColours[state?.toUpperCase()];
      } else {
        if ([Statuses.LOADING, Statuses.NOT_APPLICABLE].includes(state)) {
          return iBadgeColours.NEUTRAL;
        }
      }
    };

    return {
      iBadgeColours,
      Statuses,
      StatusStyles,
      badgeColour: computed(() => badgeColourMap(props.state)),
      badgeIcon: computed(() => statusIcon(props.state)),
    };
  },
};
</script>

<template>
  <i-badge
    :class="{ loading: state === Statuses.LOADING }"
    :colour="badgeColour"
    :label="label"
    :disabled="state === Statuses.DISABLED"
    :has-leading-icon="true"
    :icon="badgeIcon"
    :outline="type === StatusStyles.OUTLINE"
  >
    <template v-if="state === Statuses.LOADING" #leftside>
      <i-spinner size="xs" />
    </template>
  </i-badge>
</template>

<style lang="scss" scoped>
.i-badge.has-leading-icon:not(.loading) {
  :deep(.label) {
    margin-left: 6px;
  }
}
</style>
